<template>
  <div class="sp-card__content">
    <div class="sp-card__group" :class="[size, {'expand' : expand}]">
      <div 
        class="sp-card" 
        v-for="(card, index) in computedCards" 
        :class="{'tms' : card.systemId === 'TMS', 'wms' : card.systemId === 'WMS'}" 
        :key = index>
        <div class="top-content">
          <div class="card-name">
            <span>{{card.systemId | convert}}</span>
            <span class="debt-num" v-if = "card.billDebt && card.billDebt < 0">(欠款&nbsp;{{Math.abs(card.billDebt)}})</span>
          </div>
          <router-link v-if="router === 'recharge'" :to="{path: '/recharge', 
            query: {id: card.id, providerOrgId: card.providerOrgId, providerOrgName: card.providerOrgName, orgOwnerId: card.orgOwnerId, orgOwnerName: card.orgOwnerName, 
            system: card.systemId, credit: card.credit, creditUseable: card.creditUseable}}" 
            tag="a" class="charge">充值</router-link>
          <router-link v-if="router === 'deposit'" :to="{path: '/deposit', 
            query: {id: card.id, providerOrgId: card.providerOrgId, providerOrgName: card.providerOrgName, orgOwnerId: card.orgOwnerId, orgOwnerName: card.orgOwnerName, 
            system: card.systemId, credit: card.credit, creditUseable: card.creditUseable}}" 
            tag="a" class="charge">充值</router-link>
        </div>
        <div class="provider">
          <div>开卡方:&nbsp;{{card.providerOrgName}}</div>
          <div>持卡方:&nbsp;{{card.orgOwnerName}}</div>
        </div>
        <div class="amount-content">
          <div class="total">信用额度&nbsp;{{card.credit}}</div>
          <div class="balance">可用余额&nbsp;{{card.creditUseable}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cards: {
      type: Array,
      default: function() {
        return [];
      }
    },
    size: {
      type: String,
      default: "small"
    },
    router: {
      type: String,
      default: ""
    },
    expand: {
      type: [Boolean, String],
      default: false
    }
  },
  filters: {
    convert(value) {
      switch (value) {
        case "TMS":
          return "TMS物流系统";
          break;
        case "WMS":
          return "WMS仓库系统";
          break;
      }
    }
  },
  computed: {
    computedCards() {
      if (this.expand) {
        return this.cards;
      } else {
        return this.cards.slice(0, 3);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sp-card__group {
  display: flex;
  flex-direction: row;
  overflow: hidden;
  > :not(:last-child) {
    margin-right: 15px;
  }
  .sp-card {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin-bottom: 5px;
    border-radius: 8px;
    color: #fff;
    .top-content,
    .amount-content {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    .top-content {
      align-items: center;
    }
    .amount-content,
    .debt-num {
      opacity: 0.6;
    }
    .charge {
      display: block;
      text-align: center;
      color: #fff;
      opacity: 0.8;
      border: 1px solid #fff;
      border-radius: 4px;
      &:hover {
        opacity: 1;
      }
    }
    .provider {
      // font-weight: 600;
      letter-spacing: 2px;
      > div {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
    &.tms {
      background: linear-gradient(to right, #673fbc 0%, #af61d0 100%);
    }
    &.wms {
      background-image: linear-gradient(120deg, #f093fb 0%, #f5576c 100%);
    }
    &.turbo {
      background-image: linear-gradient(to right, #fa709a 0%, #fee140 100%);
    }
  }
  &.normal {
    .sp-card {
      width: 510px;
      height: 280px;
      padding: 25px;
      .charge {
        width: 80px;
      }
    }
  }
  &.small {
    .sp-card {
      width: 320px;
      height: 180px;
      padding: 15px;
      .charge {
        width: 50px;
        padding: 3px 0;
      }
    }
  }
  &.expand {
    overflow: visible !important;
    flex-wrap: wrap;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/sp-card-group.vue